<template>
  <div id="expore_more">
    <div class="solution" :style="{ padding: shrink ? '4rem 2rem' : '4rem 0' }">
      <div class="solution_label" v-translateIn>
        {{ $t("home.HOME_SOLUTION_TITLE") }}
      </div>
      <div
        class="solution_describe"
        v-html="$t('home.HOME_SOLUTION_DESCRIPTION')"
      ></div>
      <div
        class="solution_content"
        :style="{
          'flex-direction': shrink ? 'column' : 'row',
        }"
      >
        <div class="solution_content_center">
          <div
            class="thumbnail"
            v-for="(imgUrl, index) in solutionUrls"
            :key="imgUrl"
          >
            <transition name="scaleIn" mode="out-in">
              <img :src="imgUrl" alt="" v-if="index === currentIndex" />
            </transition>
          </div>
        </div>
        <div class="solution_content_right">
          <div
            class="option"
            v-slideIn="shrink ? 'none' : 'right'"
            @click="onJumpTo(routeHash.AIR_TO_LIQUID_COOLING)"
          >
            <span class="index">01.</span>
            <div class="option_right">
              <span>{{ $t("home.HOME_SOLUTION_TAG_1") }}</span>
              <img src="@/assets/arrow.svg" alt="" class="arrow" />
            </div>
          </div>
          <div
            class="option"
            v-slideIn="shrink ? 'none' : 'right'"
            @click="onJumpTo(routeHash.SYSTEMIC_LIQUID_COOLING)"
          >
            <span class="index">02.</span>
            <div class="option_right">
              <span>{{ $t("home.HOME_SOLUTION_TAG_2") }}</span>
              <img src="@/assets/arrow.svg" alt="" class="arrow" />
            </div>
          </div>
          <div
            class="option"
            v-slideIn="shrink ? 'none' : 'right'"
            @click="onJumpTo(routeHash.RDHX_AIR_COOLED)"
          >
            <span class="index">03.</span>
            <div class="option_right">
              <span>{{ $t("home.HOME_SOLUTION_TAG_3") }}</span>
              <img src="@/assets/arrow.svg" alt="" class="arrow" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="service" :style="{ padding: shrink ? '4rem 2rem' : '4rem 0' }">
      <div class="service_header">
        <div class="service_header_title" v-translateIn>
          {{ $t("home.HOME_SERVICE") }}
        </div>
        <div
          class="service_header_describe"
          v-html="$t('home.HOME_SERVICE_TITLE')"
        ></div>
      </div>
      <div
        class="service_body"
        :style="{ 'flex-direction': shrink ? 'column' : 'row' }"
      >
        <div class="service_body_left">
          <img
            src="https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/liquid_cooling_service.jpg"
            alt=""
            class="service_thumbnail"
          />
          <div class="service_body_left_mask">
            <div class="describe">
              {{ t(`service.LIQUID_COOLING_SERVICE`) }}
            </div>
            <div
              class="service_body_left_mask_btn"
              @click="onJumpTo(routeHash.IDC_LIQUID_COOLING)"
            >
              <span>{{ $t("home.HOME_SERVICE_BTN") }}</span>
              <van-icon name="arrow" color="#fff" class="arrow_left" />
            </div>
          </div>
        </div>
        <div class="service_body_right">
          <img
            src="https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/AIGC_infrastructure.jpeg"
            alt=""
            class="service_thumbnail"
          />
          <div class="service_body_right_mask">
            <div class="describe">{{ t(`service.AIGC_INFRASTRUCTURE`) }}</div>
            <div
              class="service_body_right_mask_btn"
              @click="onJumpTo(routeHash.AIGC_INFRASTRUCTURE)"
            >
              <span>{{ $t("home.HOME_SERVICE_BTN") }}</span>
              <van-icon name="arrow" color="#fff" class="arrow_left" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="product">
      <div
        class="product_content"
        :style="{
          'flex-direction': shrink ? 'column-reverse' : 'row',
          padding: shrink ? '0' : '0 3rem',
        }"
      >
        <div class="product_content_left">
          <div class="product_content_left_title" v-translateIn>
            {{ $t("home.HOME_PRODUCT_TITLE") }}
          </div>
          <!-- <transition name="fadeIn" mode="out-in"> -->
            <div class="product_content_left_describe" :key="progress">
              <span class="describe_content">{{
                products[progress].describe
              }}</span>
            </div>
          <!-- </transition> -->
          <div class="read_more" @click="onReadMore">
            <span>{{ $t("home.HOME_READ_MORE") }}</span>
            <img src="@/assets/arrow_blue.svg" alt="" />
          </div>
        </div>
        <div class="product_content_scroller">
          <div class="product_content_scroller_items">
            <div
              class="item"
              v-for="product in products"
              :key="product.assetUrl"
            >
              <div class="item_thumbnail">
                <img :src="product.assetUrl" alt="" />
              </div>
              <div class="item_label">{{ product.label }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="company" :style="{ padding: shrink ? '4rem 2rem' : '4rem 0' }">
      <div
        class="company_content"
        :style="{ 'flex-direction': shrink ? 'column' : 'row' }"
      >
        <div class="company_content_left">
          <div class="company_content_left_title" v-translateIn>
            {{ $t("home.HOME_COMPANY_TITLE") }}
          </div>
          <div
            class="company_content_left_describe"
            v-html="$t('home.HOME_COMPANY_DESCRIBE')"
          ></div>
          <div
            class="company_content_left_btn"
            @click="onJumpTo(routeHash.CONTACT_US)"
          >
            <span>{{ $t("home.BUTTON_TEXT") }}</span>
            <van-icon name="arrow" color="#25488f" class="arrow_left" />
          </div>
        </div>
        <div class="company_content_right">
          <div class="company_content_right_thumbnail">
            <img :src="aboutUsUrls[currentAboutIndex]" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="tsx">
import routeHash from "@/constant/router_hash";
import provide_key from "@/constant/provide_key";
import Mitt from "@/utils/mitt";
import { useI18n } from "vue-i18n";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";
import { ref, onMounted, inject, computed } from "vue";
import { useRouter } from "vue-router";

const { t } = useI18n();
const router = useRouter();
gsap.registerPlugin(ScrollTrigger);

const progress = ref(0);
const currentIndex = ref(0);
const shrink: boolean | undefined = inject(provide_key.SHRINK);

const solutionUrls = ref([
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/why_liquid_cooling.png",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/liquid_cooling_service.png",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/retorift.png",
]);

const aboutUsUrls = ref([
   "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_1.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_2.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_3.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_4.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_5.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_6.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_7.jpg",
]);

const currentAboutIndex = ref(0);

const onJumpTo = (hash: any) => {
  setTimeout(() => Mitt.emit(hash), 0);
  switch (hash) {
    case routeHash.AIR_TO_LIQUID_COOLING:
    case routeHash.SYSTEMIC_LIQUID_COOLING:
    case routeHash.RDHX_AIR_COOLED:
      router.push({ path: "/solution" });
      return;
    case routeHash.IDC_LIQUID_COOLING:
    case routeHash.AIGC_INFRASTRUCTURE:
      router.push({ path: "/service" });
      return;
    case routeHash.L2A_PRODUCT:
    case routeHash.L2L_PRODUCT:
    case routeHash.RDHx_PRODUCT:
    case routeHash.OTHERS_PRODUCT:
      router.push({ path: "/product" });
      return;
    case routeHash.CONTACT_US:
      router.push({ path: "/company" });
      return;
    default:
      return;
  }
};

onMounted(() => {
    setInterval(() => {
    currentAboutIndex.value = (currentAboutIndex.value + 1) % aboutUsUrls.value.length; // 更新当前索引
  }, 2000); 
  const t1 = gsap.timeline({
    scrollTrigger: {
      trigger: ".main",
      start: "top bottom", // Start the animation when the top of thumbnail_box enters the viewport
      end: `bottom top`, // End the animation when the bottom of thumbnail_box reaches the top of the viewport
      scrub: true,
    },
  });

  const t2 = gsap.timeline({
    scrollTrigger: {
      trigger: ".product",
      start: "top top",
      end: "bottom top",
      pin: true,
      pinType: "fixed",
      pinnedContainer: ".main",
      pinSpacing: true,
      scrub: 0.01,
      onUpdate: (self) => {
        if (self.progress < 1) {
          progress.value = Math.floor(self.progress / 0.25);
        }
      },
    },
  });

  const t3 = gsap.timeline({
    scrollTrigger: {
      trigger: ".service",
      start: "50% bottom",
      end: "bottom top",
      scrub: 0.001,
    },
  });

  t2.to(".product_content_scroller_items", {
    duration: 2,
    y: "-75%",
    ease: "none",
  });
  t1.to(".thumbnail_box", { y: "100vh" });
  t3.fromTo(".service_thumbnail", { y: "0" }, { y: "20%"});

  setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % solutionUrls.value.length;
  }, 2000);
});

const products = computed(() => [
  {
    assetUrl:
      "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/L2L_CDU_front.png",
    label: t("home.HOME_PRODUCT_L2L"),
    describe: t("home.HOME_PRODUCT_DESCRIBE"),
  },
  {
    assetUrl:
      "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/L2A1_front.png",
    label: t("home.HOME_PRODUCT_L2A"),
    describe: t("home.HOME_PRODUCT_DESCRIBE"),
  },
  {
    assetUrl:
      "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/near_door_thumbnail_back.png",
    label: t("home.HOME_PRODUCT_RDHx"),
    describe: t("home.HOME_PRODUCT_DESCRIBE"),
  },
  {
    assetUrl:
      "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/others1_single.png",
    label: t("home.HOME_PRODUCT_OTHER"),
    describe: t("home.HOME_PRODUCT_DESCRIBE"),
  },
]);

const onReadMore = () => {
  const productHashList = [
    routeHash.L2A_PRODUCT,
    routeHash.L2L_PRODUCT,
    routeHash.RDHx_PRODUCT,
    routeHash.OTHERS_PRODUCT,
  ];
  onJumpTo(productHashList[progress.value])
};
</script>

<style lang="less" scoped>
#expore_more {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: hidden;
  position: relative;

  .scaleIn-enter-active,
  .scaleIn-leave-active {
    transition: all 0.5s ease;
  }
  .scaleIn-enter-from {
    opacity: 0;
    transform: scale(50%);
  }
  .scaleIn-enter-to {
    opacity: 1;
    transform: scale(100%);
  }
  .scaleIn-leave-from {
    opacity: 1;
    transform: scale(100%);
  }
  .scaleIn-leave-to {
    opacity: 0;
    transform: scale(50%);
  }

  .fadeIn-enter-active,
  .fadeIn-leave-active {
    transition: all 0.5s ease;
  }
  .fadeIn-enter-from {
    opacity: 0;
    transform: translateY(30%);
  }
  .fadeIn-enter-to {
    opacity: 1;
    transform: translateY(0);
  }
  .fadeIn-leave-from {
    opacity: 1;
    transform: translateY(0);
  }
  .fadeIn-leave-to {
    opacity: 0;
    transform: translateY(-30%);
  }

  @keyframes moveLeft {
    0% {
      transform: translateX(0%);
    }
    50% {
      transform: translateX(50%);
    }
    100% {
      transform: translateX(0);
    }
  }
  .solution {
    padding: 4rem 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: var(--bg-color-white-light);
    width: 100%;
    background-image: url("@/assets/gray_back.png");
    background-position: right top;
    background-repeat: no-repeat;
    background-size: contain;

    &_label {
      width: var(--view-max-width);
      color: var(--font-color-black-light);
      font-size: var(--font-size-base);
      font-weight: var(--font-weight-base);
      text-align: left;
    }

    &_describe {
      width: var(--view-max-width);
      color: var(--font-color-black-light);
      font-size: var(--font-size-medium);
      font-weight: var(--font-weight-big);
      margin-top: 2rem;
    }

    &_content {
      display: flex;
      align-items: center;
      width: var(--view-max-width);
      gap: 6rem;
      margin-top: 2rem;

      &_right {
        display: flex;
        flex-direction: column;
        flex: 1;

        .option {
          border-bottom: 1px solid var(--font-color-gray-light);
          font-size: var(--font-size-medium);
          font-weight: var(--font-weight-medium);
          color: var(--font-color-gray-light);
          display: flex;
          align-items: center;
          cursor: pointer;
          padding: 2rem 0;
          gap: 5rem;

          .index {
            font-size: var(--font-size-base);
            font-weight: var(--font-weight-base);
          }

          &_right {
            display: flex;
            align-items: center;
          }

          &:hover {
            color: var(--font-color-black);
          }

          &:last-child {
            border: none;
          }
        }
      }

      &_center {
        width: 16rem;
        display: flex;
        align-items: center;
        display: flex;
        flex-direction: column;
        height: 32rem;
        position: relative;

        .thumbnail {
          position: absolute;
          left: 0;
          height: 40%;
          overflow: hidden;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            border-radius: 1rem;
            object-fit: cover;
            transition: 0.5s all;
          }

          &:nth-child(1) {
            top: 0;
          }

          &:nth-child(2) {
            top: 30%;
          }

          &:nth-child(3) {
            top: 60%;
          }
        }
      }
    }
  }

  .service {
    width: 100%;
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 4rem 0;
    background: var(--bg-color-white);
    border-radius: 1rem;
    justify-content: center;
    min-height: 100vh;
    position: relative;

    &_header {
      display: flex;
      justify-content: space-between;
      width: var(--view-max-width);
      overflow-y: hidden;
      flex-direction: column;
      gap: 2rem;

      &_title {
        font-size: var(--font-size-base);
        color: var(--font-color-black-light);
        font-weight: var(--font-weight-base);
      }

      &_describe {
        width: var(--view-max-width);
        color: var(--font-color-black-light);
        font-size: var(--font-size-medium);
        font-weight: var(--font-weight-big);
      }
    }

    &_body {
      display: flex;
      gap: 4rem;
      justify-content: space-between;
      height: 24rem;
      width: 100%;
      max-width: var(--view-max-width);
      flex: 1;

      &_left {
        height: 30rem;
        border-radius: 1rem;
        background-size: cover;
        flex: 1;
        position: relative;
        overflow: hidden;

        .service_thumbnail {
          position: absolute;
          bottom: 0;
          left: 0;
          height: 120%;
          width: 100%;
          z-index: 1;
          object-fit: cover;
        }

        &_mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.4);
          display: flex;
          flex-direction: column;
          gap: 2rem;
          align-items: center;
          justify-content: center;
          z-index: 2;

          .describe {
            max-width: 25rem;
            color: var(--font-color-white-strong);
            font-size: var(--font-size-might);
            font-weight: var(--font-weight-medium);
          }

          &_btn {
            height: fit-content;
            padding: 0.5rem 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            border-radius: 0.2rem;
            border: 1px solid #fff;
            cursor: pointer;

            &:hover {
              .arrow_left {
                animation: moveLeft 1s infinite;
              }
            }

            span {
              font-size: var(--font-size-smalll);
              color: var(--font-color-white-strong);
            }
          }
        }
      }

      &_right {
        position: absolute;
        top: 0;
        right: 0;
        height: 30rem;
        border-radius: 1rem;
        background-size: cover;
        flex: 1;
        position: relative;
        overflow: hidden;

        .service_thumbnail {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 120%;
          z-index: 1;
          object-fit: cover;
        }

        &_mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.4);
          display: flex;
          flex-direction: column;
          gap: 2rem;
          align-items: center;
          justify-content: center;
          z-index: 2;

          .describe {
            max-width: 25rem;
            color: var(--font-color-white-strong);
            font-size: var(--font-size-might);
            font-weight: var(--font-weight-medium);
          }

          &_btn {
            height: fit-content;
            padding: 0.5rem 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            border-radius: 0.2rem;
            border: 1px solid #fff;
            cursor: pointer;

            &:hover {
              .arrow_left {
                animation: moveLeft 1s infinite;
              }
            }

            span {
              font-size: var(--font-size-base);
              color: var(--font-color-white-strong);
            }
          }
        }
      }
    }
  }

  .product {
    width: 100%;
    background: var(--bg-color-blue-liner);
    display: flex;
    align-items: center;
    gap: 3rem;
    height: 100vh;
    justify-content: center;

    &_content {
      width: var(--view-max-width);
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      position: relative;

      &_left {
        display: flex;
        flex-direction: column;
        flex: 3;
        overflow-y: hidden;

        &_title {
          display: flex;
          flex-direction: column;
          justify-content: center;
          font-size: var(--font-size-big);
          font-weight: var(--font-weight-plus);
          color: var(--font-color-black-light);
          border-left: 0.25rem solid var(--font-color-blue-dark);
          padding-left: 1rem;
        }

        &_describe {
          font-size: var(--font-size-base);
          color: var(--font-color-gray-light);
          font-weight: var(--font-weight-base);
          max-width: 22rem;
          display: flex;
          align-items: center;
          position: absolute;
          left: 3rem;
          bottom: 25%;
          height: 8rem;
        }

        .read_more {
          font-size: var(--font-size-base);
          color: var(--font-color-blue-dark);
          font-weight: var(--font-weight-base);
          border: 1px solid var(--font-color-blue-dark);
          cursor: pointer;
          display: flex;
          align-items: center;
          width: fit-content;
          padding: 0.3rem 0.8rem;
          border-radius: 0.2rem;
          position: absolute;
          left: 3rem;
          bottom: 20%;

          img {
            width: 1rem;
            height: 1rem;
          }
        }
      }

      &_scroller {
        height: 100%;
        overflow: hidden;
        flex: 4;

        &_items {
          width: fit-content;
          display: flex;
          align-items: center;
          flex-direction: column;
          width: 100%;
          height: 400%;

          .item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 1rem;
            width: 100%;
            height: 100%;
            padding: 0 5rem;

            &_thumbnail {
              width: 100%;
              overflow: hidden;
              cursor: pointer;
              padding: 2rem 2rem 0 2rem;
              transition: 1s all;
              display: flex;
              justify-content: center;
              max-height: 50%;
              border-radius: 0.5rem;

              &:hover {
                transform: scale(0.98);

                img {
                  transform: scale(1.12);
                }
              }

              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                transition: 1s all;
              }
            }

            &_label {
              font-size: var(--font-size-medium);
              color: var(--font-color-blue-dark);
              font-weight: var(--font-weight-big);
              display: flex;
              justify-content: center;
              overflow-y: hidden;
            }
          }
        }
      }
    }
  }

  .company {
    padding: 4rem 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--bg-color-white-light);
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    min-height: 100vh;
    background-image: url("@/assets/gray_strong_back.png");
    background-position: left top;
    background-repeat: no-repeat;
    background-size: contain;

    &_content {
      width: var(--view-max-width);
      display: flex;
      justify-content: space-between;
      gap: 3rem;
      align-items: center;

      &_left {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        flex: 1;

        &_btn {
          width: fit-content;
          padding: 0.5rem 1rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          border-radius: 0.2rem;
          border: 1px solid var(--font-color-blue-dark);
          cursor: pointer;

          &:hover {
            .arrow_left {
              animation: moveLeft 1s infinite;
            }
          }

          span {
            font-size: 1rem;
            color: var(--font-color-blue-dark);
          }
        }

        &_title {
          width: var(--view-max-width);
          color: var(--font-color-black-light);
          font-size: 1rem;
          text-align: left;
        }

        &_describe {
          margin-top: 2rem;
          color: var(--font-color-black-light);
          font-size: 2rem;
          font-weight: 600;
        }
      }

      &_right {
        width: 28rem;
        display: flex;
        align-items: center;

        &_thumbnail {
          height: 20rem;
          width: 28rem;
          border-radius: 1rem;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }
}

::v-deep .highlight {
  color: var(--font-color-blue-dark);
}
</style>